export default __webpack_public_path__ + "static/media/feePicture1.91d18e53.png";